import React, { useEffect, useState } from 'react'
import { Switch, Route } from 'react-router-dom'

import store from '../store'

import userModel from '../store/user'
import organisationModel from '../store/organisation'
import questionModel from '../store/question'
import questionnaireModel from '../store/questionnaire'

import Dashboard from './Dashboard'
import User from './user'
import Organisation from './organisation'
import Question from './question'
import Questionnaire from './questionnaire'
import Test from './test'

const AdminIndex = () => {
    const [storeLoaded, setLoaded] = useState(false)

    useEffect(() => {
        const { resolveRehydration: resolveUser } = store.addModel('user', userModel)
        const { resolveRehydration: resolveOrganisation } = store.addModel('organisation', organisationModel)
        const { resolveRehydration: resolveQuestion } = store.addModel('question', questionModel)
        const { resolveRehydration: resolveQuestionnaire } = store.addModel('questionnaire', questionnaireModel)

        Promise.all([
            resolveUser,
            resolveOrganisation,
            resolveQuestion,
            resolveQuestionnaire]
        ).then(() => setLoaded(true))
    }, [])

    if (!storeLoaded) return null

    return (
        <Switch>
            <Route path="/admin/user" component={User} />
            <Route path="/admin/organisation" component={Organisation} />
            <Route path="/admin/question" component={Question} />
            <Route path="/admin/questionnaire" component={Questionnaire} />
            <Route path="/admin/test" component={Test} />
            <Route component={Dashboard} />
        </Switch>
    )
}

export default AdminIndex